export const baseURL = "https://licence.equestrian.ca/resultsws/wcf/ResultsWCF.svc/";

export const compIdTest = "1111";
export const passwordTest = "barn";
